/* ============================================================================================================
   DW GIFT GUARD  (CRO, 2026-09-22, round 3; gift-card option removed per CEO ruling for the GWP Fix sandbox)
   The free Mystery Gift (Rebuy Smart Cart tiered progress bar, CA bar, product tier at 150.00 CAD) must only
   stay in carts that genuinely qualify. Rebuy checks the tier in the browser only, so three routes let the $0
   gift reach checkout on a smaller cart:
     A  a visitor who sees US dollars on devoteewear.com but whom Rebuy's IP lookup places in Canada gets the
        CA bar, converted to USD (gift at US$109.07);
     C  a direct /cart/add.js of the gift variant (no Rebuy tag) is never removed by Rebuy;
     M  checkout clicked in the ~1 s before Rebuy removes the gift after the cart drops.
   This file:
     1. NEVER adds anything. It only removes gift lines (or trims the gift to 1 unit) on carts that do not
        qualify, so a genuine CA$150+ cart gets zero writes from it.
     2. Qualifying amount = cart.total_price (after automatic discounts and any code applied to the cart)
        minus the gift line(s). Gift cards and other Rebuy lines (paid widget items) COUNT, like in
        Rebuy's own subtotal (Rebuy subtracts only lines tagged 'Rebuy Tiered Progress Bar').
        The cart must be in the shop currency (CAD); a USD cart never qualifies (the US bar has no gift).
     3. Bar choice by page currency. The inline pre-empt in theme.liquid wraps Rebuy.SmartCart.getBarForLocation
        before Rebuy picks its bar: CAD pages are unchanged; USD pages get the bar Rebuy gives a US visitor (free
        shipping only); any other currency gets no gift bar (what Rebuy already shows a real non-CA/US visitor).
        Backstop here if the pre-empt was too late: a USD page holding the gift bar is switched to the US bar.
        Feature-detected; without Rebuy's functions the removal + checkout gate below still apply.
     4. Loop protection: at most 2 removals of Rebuy-TAGGED gift lines for the same cart contents (keyed on the
        NON-gift lines, currency and total; a count expires after 10 minutes). Untagged lines (direct adds) are exempt: Rebuy never re-adds them, so
        removing them cannot loop. Hard stop: 6 removals per page load. Then it fires dw:gift-guard:conflict.
     5. Checkout gate: a click on any checkout button first waits for any cart write already in flight (e.g. a
        drawer minus clicked just before), then re-reads the cart and removes a non-qualifying gift before
        letting the click through; if another cart write started meanwhile it checks again (max 3 rounds). The gate ignores both caps. It fails open after 2.5 s so a slow
        network can never block a sale. Express buttons: a Shop Pay button in the page DOM is stopped only when
        the last known cart already holds a non-qualifying gift (the shopper taps again). PayPal express draws
        inside a cross-origin iframe, so its clicks never reach this code and cannot be gated. Both are hidden
        (0x0) in the Rebuy drawer today.
   Not covered (outside the theme): a discount code typed on the checkout page, a cart permalink straight to
   checkout, JavaScript off. Switch off: Theme settings > Free gift guard (DW) > untick.
   ============================================================================================================ */
(function () {
  'use strict';
  var C = window.DWGiftGuard;
  if (!C || !C.enabled || window.__dwGiftGuardLoaded) return;
  window.__dwGiftGuardLoaded = true;
  if (window.Shopify && window.Shopify.designMode) return;

  var GIFT_PRODUCT = Number(C.productId) || 0;
  var MIN = Math.round(Number(C.minCents) || 0);
  var CUR = String(C.currency || '').toUpperCase();
  if (!GIFT_PRODUCT || !MIN || !CUR) return;

  var TPB = 'Rebuy Tiered Progress Bar';
  var PER_SIGNATURE = 2, PAGE_CAP = 6, SETTLE_MS = 1500, GATE_TIMEOUT_MS = 2500, CAP_TTL_MS = 10 * 60 * 1000;
  var GATE_SEL = '.rebuy-cart__checkout-button, .rebuy-cart__shop-pay-button, button[name="checkout"], input[name="checkout"], #checkout, a[href="/checkout"], a[href^="/checkout?"], a[href$="/checkout"]';
  var WALLET_SEL = '[data-rebuy-cart-additional-checkout-buttons], shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .additional-checkout-buttons, .dynamic-checkout__content';

  var state = C.state = { removals: 0, runs: 0, lastDecision: null, conflicts: 0, barSwapped: false, gate: [] };
  var memoryStore = {};
  var lastCart = null, timer = null, chain = Promise.resolve(), bypass = false, gateBusy = false, barBusy = false;
  var inflight = 0, lastWriteAt = 0, selfWriting = false;
  var WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  /* Track cart writes made by anyone on the page (Rebuy, theme, quick-add) so the checkout gate can wait for them. */
  function writeStarted() { inflight++; lastWriteAt = Date.now(); var d = false; return function () { if (!d) { d = true; inflight = Math.max(0, inflight - 1); } }; }
  try {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function' && !origFetch.__dwgg) {
      var wrappedFetch = function (input) {
        var u = ''; try { u = String((input && input.url) || input); } catch (e) {}
        var p = origFetch.apply(this, arguments);
        if (!selfWriting && WRITE_RE.test(u.split('#')[0])) { var done = writeStarted(); p.then(done, done); }
        return p;
      };
      wrappedFetch.__dwgg = 1;
      window.fetch = wrappedFetch;
    }
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__dwggUrl = String(u); } catch (e) {} return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      try { if (this.__dwggUrl && WRITE_RE.test(this.__dwggUrl)) { var done = writeStarted(); this.addEventListener('loadend', done); } } catch (e) {}
      return XS.apply(this, arguments);
    };
  } catch (e) {}
  function waitIdle(deadline) {
    return new Promise(function (res) { (function tick() { if (inflight === 0 || Date.now() > deadline) return res(); setTimeout(tick, 40); })(); });
  }

  function log() {
    try { if (C.debug || /[?&]dwgg=1/.test(location.search)) console.log.apply(console, ['[dw-gift-guard]'].concat([].slice.call(arguments))); } catch (e) {}
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function isGift(l) { return Number(l.product_id) === GIFT_PRODUCT; }
  function isTagged(l) { return !!(l.properties && l.properties._attribution === TPB); }

  /* Pure decision, exposed for tests. Returns the /cart/update.js payload needed (empty when nothing to do). */
  function decide(cart) {
    var items = (cart && cart.items) || [], gifts = [], giftTotal = 0;
    items.forEach(function (l) {
      if (isGift(l)) { gifts.push(l); giftTotal += Number(l.final_line_price || 0); }
    });
    var currencyOk = String((cart && cart.currency) || '').toUpperCase() === CUR;
    var qualifying = Number((cart && cart.total_price) || 0) - giftTotal;
    var eligible = currencyOk && qualifying >= MIN;
    var updates = {}, count = 0;
    if (gifts.length) {
      if (!eligible) {
        gifts.forEach(function (l) { updates[l.key] = 0; count++; });
      } else {
        var keep = gifts.filter(isTagged)[0] || gifts[0];
        gifts.forEach(function (l) {
          if (l.key === keep.key) { if (l.quantity > 1) { updates[l.key] = 1; count++; } }
          else { updates[l.key] = 0; count++; }
        });
      }
    }
    return { eligible: eligible, currencyOk: currencyOk, qualifying: qualifying, gifts: gifts.length, updates: updates, count: count };
  }
  C.decide = decide;

  function signature(cart) {
    var parts = (cart.items || []).filter(function (l) { return !isGift(l); })
      .map(function (l) { return l.variant_id + 'x' + l.quantity; }).sort();
    return 'dwgg:' + String(cart.currency) + ':' + (Number(cart.total_price) - (cart.items || []).filter(isGift)
      .reduce(function (s, l) { return s + Number(l.final_line_price || 0); }, 0)) + ':' + parts.join(',');
  }
  /* Counts expire after CAP_TTL_MS: a Rebuy re-add loop happens within seconds, so an old count must not
     block a later, legitimate clean-up of the same cart contents (e.g. after the Back button). */
  function getCount(k) {
    var raw = null;
    try { raw = window.sessionStorage.getItem(k); } catch (e) {}
    if (raw === null && memoryStore[k] !== undefined) raw = memoryStore[k];
    if (raw === null || raw === undefined) return 0;
    var parts = String(raw).split('|'), n = Number(parts[0]) || 0, at = Number(parts[1]) || 0;
    return (Date.now() - at > CAP_TTL_MS) ? 0 : n;
  }
  function setCount(k, n) {
    var v = n + '|' + Date.now();
    memoryStore[k] = v;
    try { window.sessionStorage.setItem(k, v); } catch (e) {}
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }
  function postUpdates(updates) {
    selfWriting = true;
    var req;
    try {
      req = fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } finally { selfWriting = false; }
    return req.then(function (r) { if (!r.ok) throw new Error('update.js ' + r.status); return r.json(); });
  }
  function refreshUi(cart) {
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } })); } catch (e) {}
    try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
    if (C.cartPage) { try { window.location.reload(); } catch (e) {} }
  }

  /* One check. force = checkout gate: ignores both caps. Serialised so two checks never overlap. */
  function check(reason, force) {
    var p = chain.then(function () {
      state.runs++;
      return fetchCart().then(function (cart) {
        lastCart = cart;
        var d = decide(cart);
        state.lastDecision = { reason: reason, at: Date.now(), eligible: d.eligible, qualifying: d.qualifying, currency: cart.currency, gifts: d.gifts, count: d.count };
        if (!d.count) return { acted: false, decision: d };
        if (!force) {
          if (state.removals >= PAGE_CAP) { conflict('page-cap', d); return { acted: false, decision: d, capped: 'page' }; }
          /* The per-cart cap only applies when a Rebuy-tagged line is being touched (Rebuy can re-add those). */
          var touchesTagged = (cart.items || []).some(function (l) { return isGift(l) && isTagged(l) && (l.key in d.updates); });
          if (touchesTagged) {
            var k = signature(cart), n = getCount(k);
            if (n >= PER_SIGNATURE) { conflict('signature-cap', d); return { acted: false, decision: d, capped: 'signature' }; }
            setCount(k, n + 1);
          }
        }
        state.removals++;
        log('removing', reason, d);
        return postUpdates(d.updates).then(function (next) {
          lastCart = next;
          refreshUi(next);
          try { document.dispatchEvent(new CustomEvent('dw:gift-guard:removed', { detail: { reason: reason, decision: d } })); } catch (e) {}
          return { acted: true, decision: d };
        });
      });
    })['catch'](function (e) { log('check failed', reason, e && e.message); return { acted: false, error: String(e && e.message) }; });
    chain = p.then(function () {}, function () {});
    return p;
  }
  function conflict(kind, d) {
    state.conflicts++;
    log('stopped (' + kind + ')', d);
    try { document.dispatchEvent(new CustomEvent('dw:gift-guard:conflict', { detail: { kind: kind, decision: d } })); } catch (e) {}
  }
  C.inflight = function () { return inflight; };
  C.runCheck = check; /* test seam: runCheck(reason, force) -> Promise of { acted, decision, capped } */
  function schedule(reason) {
    clearTimeout(timer);
    timer = setTimeout(function () { swapBarIfNeeded(); check(reason, false); }, SETTLE_MS);
  }

  /* Route A: a non-CAD visitor holding the CA (gift) bar gets the bar Rebuy would give a US visitor. */
  function hasProductTier(bar) { return !!(bar && (bar.tiers || []).some(function (t) { return t && t.type === 'product'; })); }
  function swapBarIfNeeded() {
    try {
      var SC = window.Rebuy && window.Rebuy.SmartCart;
      var cur = String((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '').toUpperCase();
      if (barBusy || !SC || !SC.progressBar || !cur || cur === CUR || !hasProductTier(SC.progressBar)) return;
      /* Only USD maps to the US bar. Other currencies: the pre-empt gives no gift bar; if it was late, the
         removal below keeps the gift out (non-CAD carts never qualify). */
      if (cur !== 'USD') return;
      if (typeof SC.getBarForLocation !== 'function' || typeof SC.getTieredBarProductData !== 'function') { log('bar swap unavailable'); return; }
      var bar = SC.getBarForLocation(C.fallbackCountry || 'US');
      if (!bar || hasProductTier(bar)) return;
      barBusy = true;
      Promise.resolve(SC.getTieredBarProductData(bar)).then(function (pb) {
        if (!pb || hasProductTier(pb)) return;
        SC.progressBar = pb;
        state.barSwapped = pb.name || true;
        if (typeof SC.updateFreeProducts === 'function') return SC.updateFreeProducts();
      }).then(function () {
        try { if (SC.view && typeof SC.view.$forceUpdate === 'function') SC.view.$forceUpdate(); } catch (e) {}
      })['catch'](function (e) { log('bar swap failed', e && e.message); })
        .then(function () { barBusy = false; schedule('after-bar-swap'); });
    } catch (e) { barBusy = false; log('bar swap error', e && e.message); }
  }

  /* Checkout gate (capture phase on window, so it runs before Rebuy's and the theme's own handlers). */
  window.addEventListener('click', function (e) {
    if (bypass || !e.target || !e.target.closest) return;
    var wallet = e.target.closest(WALLET_SEL);
    if (wallet) {
      if (lastCart && decide(lastCart).count) {
        e.preventDefault(); e.stopImmediatePropagation();
        state.gate.push({ at: Date.now(), kind: 'wallet-stopped' });
        check('gate-wallet', true);
      }
      return;
    }
    var btn = e.target.closest(GATE_SEL);
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (gateBusy) return;
    gateBusy = true;
    var started = Date.now(), done = false;
    var resume = function (how) {
      if (done) return; done = true; gateBusy = false;
      state.gate.push({ at: started, ms: Date.now() - started, kind: how });
      bypass = true;
      try { btn.click(); } catch (err) {} finally { bypass = false; }
    };
    setTimeout(function () { resume('timeout'); }, GATE_TIMEOUT_MS);
    var deadline = started + GATE_TIMEOUT_MS - 300, acted = false, rounds = 0, waited = inflight > 0;
    var round = function () {
      rounds++;
      var mark = Date.now();
      return waitIdle(deadline).then(function () { return check('gate', true); }).then(function (res) {
        if (res && res.acted) acted = true;
        if (rounds < 3 && Date.now() < deadline && (inflight > 0 || lastWriteAt > mark)) { waited = true; return round(); }
        return res;
      });
    };
    round().then(function () { resume((acted ? 'removed-then-continued' : 'clean') + (waited ? '-after-wait' : '') + '-r' + rounds); }, function () { resume('error'); });
  }, true);

  /* Triggers: any cart request on the page (whoever made it), Rebuy and theme cart events, page show. */
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (en) {
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(en.name)) schedule('network');
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) { log('no PerformanceObserver'); }
  ['rebuy:cart.change', 'rebuy:cart.ready', 'rebuy:smartcart.ready'].forEach(function (n) {
    document.addEventListener(n, function () { swapBarIfNeeded(); schedule(n); });
  });
  /* Backstop bar check as soon as Rebuy has a bar (no SETTLE_MS wait): every 100 ms for up to 10 s. */
  (function () {
    var tries = 0, iv = setInterval(function () {
      tries++;
      var SC = window.Rebuy && window.Rebuy.SmartCart;
      if (SC && SC.progressBar) { swapBarIfNeeded(); clearInterval(iv); } else if (tries >= 100) clearInterval(iv);
    }, 100);
  })();
  window.addEventListener('pageshow', function () { schedule('pageshow'); });
  schedule('load');
})();
